import { filterByGameLocationsAndResults } from '@/utils/playsFiltering';
import { getTeamTableData } from '@/utils/teamTableData';
import { getLocalVsVisitorData } from '@/data/generators/localVsVisitorData';
import { offensiveValues } from '@/data/statisticsLocalVsVisitorValues';
import { getSoccerGoalData } from '@/data/generators/soccerGoalData';
import teamStatsPlayIndexes from '@/data/team/teamStatsPlayIndexes';
import teamGoalPlayIndexes from '@/data/team/teamGoalPlayIndexes';
import { getChalkboardPlayList, getChalkboardGames } from '@/data/generators/soccerChalkboardData';
import { offensive } from '@/data/team/featured-players-categories';

const state = {
  indexes: teamStatsPlayIndexes(),
  basePlaysStack: [],
  goalPlaysStack: [],
  categories: [
    {
      name: 'Goles',
      color: '#4A90E2',
      points: [1, 2, 3],
      categories: [12],
      negative: false,
    },
    {
      name: 'Tiros a gol',
      color: '#F2E82E',
      points: [1, 2, 3],
      categories: [540, 547, 537, 544],
      negative: false,
    },
    {
      name: 'Tiros a gol (portería)',
      color: '#8E17EF',
      points: [1, 2, 3],
      categories: [539, 542, 546, 549],
    },
    {
      name: 'Centros totales',
      color: '#FF8000',
      points: [1, 2, 3],
      categories: [109, 112, 115, 116, 104, 105, 98, 101],
    },
    {
      name: 'Centros acertados',
      color: '#068A8E',
      points: [1, 2, 3],
      categories: [106, 107, 108, 117, 118, 119],
    },
    {
      name: 'Aéreos en área rival',
      color: '#FB04C7',
      points: [1, 2],
      categories: [40],
    },
    {
      name: '1vs1 exitosos ofensivos',
      color: '#606060',
      points: [1],
      categories: [4],
    },
    {
      name: '1vs1 no exitosos ofensivos',
      color: 'green',
      points: [1],
      categories: [208],
    },
    {
      name: 'Balones ganados en área rival',
      color: 'cyan',
      points: [1, 2, 3],
      categories: [11],
    },
  ],
  featuredPlayersCategories: offensive,
  plays1: [[53010, 183, 2, 1, 1]],
};

const mutations = {
  updatePlaysStack(state, playsStack) {
    state.basePlaysStack = playsStack;
  },
  updateGoalPlaysStack(state, playsStack) {
    state.goalPlaysStack = playsStack;
  },
};

const getters = {
  getPlaysStack(state, getters, rootState, rootGetters) {
    const sections = rootGetters['filterGeneral/getSections'];
    return getters.filteredPlaysStack.filter(play => sections.includes(play[state.indexes.section]));
  },
  filteredPlaysStack(state, getters, rootState, rootGetters) {
    return filterByGameLocationsAndResults(
      state.basePlaysStack,
      rootGetters['filterGeneral/getPlayingAs'],
      rootGetters['filterGeneral/getResults'],
      rootGetters['filterGeneral/getSelectedGamesIds'],
      teamStatsPlayIndexes(),
      rootGetters['teamsGeneral/team'].team_id,
    );
  },
  tableData(state, getters, rootState, rootGetters) {
    //Stadistic_id helps to select if data current average is divided by games played or season teams
    const STADISTIC_ID = rootGetters['filterGeneral/getStadisticId'];
    const totalSeasonGamesOrTeams =
      STADISTIC_ID === 0
        ? rootGetters['gamesGeneral/gamesPlayed']
        : rootGetters['teamsGeneral/teamsForAnalysis'].length;

    return getTeamTableData(
      2,
      getters.filteredPlaysStack,
      rootGetters['leagueGeneral/filteredPlaysStack'],
      rootGetters['filterGeneral/getSections'],
      totalSeasonGamesOrTeams,
      rootGetters['teamsGeneral/team'].team_id,
    );
  },
  localVsVisitorData(state, getters, rootState, rootGetters) {
    return getLocalVsVisitorData(
      getters.filteredPlaysStack,
      rootGetters['filterGeneral/getSections'],
      offensiveValues,
      teamStatsPlayIndexes(),
      rootGetters['teamsGeneral/team'].team_id,
    );
  },
  chalkboardPlays(state, getters, rootState, rootGetters) {
    return getChalkboardPlayList(
      getters.filteredPlaysStack,
      rootGetters['filterGeneral/getSections'],
      teamStatsPlayIndexes(),
    );
  },
  chalkboardGames(state, getters, rootState, rootGetters) {
    return getChalkboardGames(
      rootGetters['teamsGeneral/teamsForAnalysis'],
      rootGetters['gamesGeneral/seasonGamesPlayed'],
    );
  },
  goalPlays(state, getters, rootState, rootGetters) {
    return getSoccerGoalData(
      state.goalPlaysStack,
      rootGetters['filterGeneral/getPlayingAs'],
      rootGetters['filterGeneral/getResults'],
      rootGetters['filterGeneral/getSections'],
      rootGetters['filterGeneral/getSelectedGamesIds'],
      teamGoalPlayIndexes(),
    );
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
};
